<script setup>
import { Row, Toggle, Hints, Heading, Suggestions, Badge } from '@components'
import DarkModeStore from '@o/store'
const { options, isLocked, showModal } = DarkModeStore()
const { __ } = wp.i18n

// On change options.performance_exclude_cache.
const changeExcludeCache = () => {
  
    if (options.performance_exclude_cache) {
        showModal({
            title: __('Are you sure?', 'wp-dark-mode'),
            message: __('Enabling this feature may delay WP Dark Mode to be applied on the frontend. Enable this feature only if you are facing issues with server-side caching.', 'wp-dark-mode'),
            confirmText: __('Enable', 'wp-dark-mode'),
            cancelText: __('Cancel', 'wp-dark-mode'),
            confirm: () => {
                options.performance_exclude_cache = true
            },
            cancel: () => {
                options.performance_exclude_cache = false
            }
        })

        return;
    } else {
        options.performance_exclude_cache = false
    }
}

</script>
<template>
    <Row transparent>

        <Heading class="mt-5"><div class="flex items-center gap-3">
            <Row inline center transparent>
                <Row transparent locked :ProBadge="false">{{__('Choose Dark Mode behavior to enhance the performance', 'wp-dark-mode')}}</Row>
                <ProBadge /> 
            </Row></div></Heading>

        <Row space gap="5" locked>
            <div v-for="(behavior, key) in $default.performance.execute_as.options" :key="key" class="flex flex-col gap-3">
                <label class="flex sm:items-center gap-3 cursor-pointer group" @click.prevent="options.performance_execute_as = key">
                    <div class="flex items-center justify-center">
                        <span class="flex w-4 rounded-full h-4 shadow group-hover:bg-blue-100"
                        :class="{ 'border-4 border-blue-500': key === options.performance_execute_as, 'border border-gray-300': key !== options.performance_execute_as }"></span>
                    </div>
                    <span class="font-medium leading-6 text-base flex items-center gap-3">{{ behavior.name }} <span class="bg-indigo-50 font-semibold text-indigo-600 border border-indigo-400 text-xs px-3 py-1 rounded-full" v-if="key === 'sync'">Recommended</span></span>
                </label>
                <Hints> {{ behavior.description }} </Hints>
            </div>
        </Row>
        
        <Heading class="mt-5"><div class="flex items-center gap-3">
            <Row inline center transparent>
                <Row transparent>{{__('Other Performance Settings', 'wp-dark-mode')}}</Row>
            </Row></div></Heading>

        <Row space gap="5">
    
            <Row transparent>
                <Row inline><Toggle v-model="options.performance_track_dynamic_content">{{__('Track Dynamic Content', 'wp-dark-mode')}}</Toggle> </Row>
                <Hints>{{__('Please turn on this feature only if you have any Ajax Loaded dynamic content like ajax product filters, ajax page loader, ajax image loaders/sliders, lazy loaded images etc.', 'wp-dark-mode')}}</Hints>
            </Row>
            <Row transparent :data-wp-dark-mode-locked="isLocked">
                <Row inline>
                    <Toggle v-model="options.performance_load_scripts_in_footer" locked> {{__('Load Scripts in Footer', 'wp-dark-mode')}}</Toggle>
                    </Row>
                <Hints locked>{{__('Enable this feature to improve page load performance and reduce render-blocking', 'wp-dark-mode')}}</Hints>
            </Row>


            <!-- Exclude caches  -->
            <Row transparent>
                <Row inline @click.prevent="changeExcludeCache">
                    <Toggle v-model="options.performance_exclude_cache">{{__('Exclude WP Dark Mode from Caching', 'wp-dark-mode')}}</Toggle>
                    </Row>
                <Hints>{{__('Enable this feature to exclude WP Dark Mode from server-side caching technology like Lightspeed Cache, WPRocket etc.', 'wp-dark-mode')}}</Hints>
            </Row>
        </Row>

        

        <Suggestions paths="shortcode, excludes"></Suggestions>
    </Row>
</template>